import { FC } from 'react'

import { FitModel } from '../../../../types/graphql'
import { CenteredTileLayout } from '../../CenteredTileLayout'
import { FitModelTile } from '../FitModelTile'

import { Wrapper } from './styles'

/**
 * Desktop: centered carousel, fixed slide size.
 * Mobile: centered slider, fixed slide size.
 */
export const FitModelTileLayout: FC<{
  activeFitModel?: FitModel
  fitModels: ReadonlyArray<FitModel>
  onTileClick(fitModel: FitModel): void
}> = ({ activeFitModel, fitModels, onTileClick }) => (
  <Wrapper>
    <CenteredTileLayout
      keyFromTile={(fitModel: FitModel, index: number) => `${index} ${fitModel.name}`}
      layoutVariantDesktop='slider'
      layoutVariantMobile='slider'
      liftedButtons
      renderTile={(fitModel: FitModel) => (
        <FitModelTile
          {...fitModel}
          isActive={fitModel.name === activeFitModel?.name}
          onClick={() => onTileClick(fitModel)}
        />
      )}
      tiles={fitModels}
      tileGapDesktop={24}
      tileGapMobile={24}
      hideSectionSideGaps
      visibleTilesMobile={1}
      visibleTilesDesktop={6}
      minTileWidth={200}
      maxTileWidth={300}
    />
  </Wrapper>
)
